import React, { useState } from "react";
import Popper from "@mui/material/Popper";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import moment from "moment";
import { useTheme, useMediaQuery, Box } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  popperContainer: {
    padding: theme.spacing(2),
    width: 300,
    maxWidth: "100%",
    boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)",
    borderRadius: "8px",
    backgroundColor: "#fff",
    overflow: "hidden",
    transition: "all 0.3s ease",
  },
  header: {
    backgroundColor: "#0078d4",
    padding: theme.spacing(1),
    borderRadius: "8px 8px 0 0",
    color: "#fff",
    fontWeight: "bold",
    textAlign: "center",
    fontSize: "16px",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    whiteSpace: "normal",
  },
  eventDetails: {
    marginTop: theme.spacing(1),
    color: "#333",
    fontSize: "14px",
    width: "100%",
    wordBreak: "break-word",
    overflowWrap: "break-word",
  },
  eventItem: (props) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    color: props.textColor || "#333",
    padding: "3px 5px",
    //borderRadius: "50px",
    //background: `linear-gradient(145deg,${props.borderColor}, #f0f0f0)`,
    borderLeft: `3px solid ${props.borderColor}`,
    background: `rgb(230, 230, 250)`,
    boxShadow: "5px 5px 8px #acacac, -5px -5px 8px #ffffff",
    cursor: "pointer",
    //fontSize: "16px",
    width: "100%",
    overflow: "hidden",
  }),
  icon: {
    marginRight: "12px",
    width: 24,
    height: 24,
    color: "#0078d4",
  },
  title: (props) => ({
    flex: 1,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    color: props.titleColor || "#333",
    fontWeight: "bold",
  }),
  time: {
    width: "80px",
    color: "#0078d4",
    textAlign: "right",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontWeight: "bold",
  },
  centeredIcon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
}));

const EventWithPopover = ({ eventInfo }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [anchorEl, setAnchorEl] = useState(null);

  const {
    title,
    start,
    backgroundColor,
    borderColor,
    extendedProps: { description, icon, textColor },
  } = eventInfo.event;

  const classes = useStyles({ isSmallScreen, textColor, borderColor });

  // Function to open popover on mouse events or touch/click events
  const handlePopoverOpen = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div
        // onMouseEnter={handlePopoverOpen}
        // onMouseLeave={handlePopoverClose}
        // onTouchStart={handlePopoverOpen}
        //onClick={handlePopoverOpen}
        className={!isSmallScreen ? classes.eventItem : ""}
      >
        {isSmallScreen ? (
          <Box className={classes.centeredIcon}>
            {icon && <span className={classes.icon}>{icon}</span>}
          </Box>
        ) : (
          <>
            {icon && <span className={classes.icon}>{icon}</span>}
            <span className={classes.title}>{title}</span>
            <span className={classes.time}>
              {moment(start).format("hh:mm A")}
            </span>
          </>
        )}
      </div>

      <Popper
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        placement="left"
        disablePortal
        sx={{ zIndex: "1300" }}
      >
        <Paper className={classes.popperContainer}>
          <div className={classes.header}>{title}</div>
          <div className={classes.eventDetails}>
            <Typography
              variant="body2"
              sx={{ color: "#666", marginBottom: "5px" }}
            >
              {moment(start).format("MMMM D, YYYY h:mm A")}
            </Typography>
            {description && (
              <Typography
                variant="body2"
                component="p"
                sx={{
                  color: "#333",
                  wordBreak: "break-word",
                  overflowWrap: "break-word",
                  whiteSpace: "normal",
                }}
              >
                {description}
              </Typography>
            )}
          </div>
        </Paper>
      </Popper>
    </>
  );
};

export default EventWithPopover;
